<div class="drawn-item" data-cy="drawn-list-item">
    <div class="placeholder"></div>
    <div class="item-content" (click)="onClickEvent()">
        <div class="header">Tegnet område</div>
    </div>
    <div class="icon in-list" (click)="this.onRemove.emit(this.polygon())"></div>
</div>
